define([
    'santa-components',
    'lodash',
    'skins',
    'spotifyFollow/skins/skins.json',
    'componentsCore'
], function (santaComponents, _, skinsPackage, skinsJson, componentsCore) {
    'use strict';

    const DEFAULT_SIZES = {
        largeWithCounter: {
            width: 228,
            height: 58,
            type: 'detail'
        },
        large: {
            width: 170,
            height: 60,
            type: 'detail'
        },
        smallWithCounter: {
            width: 162,
            height: 27,
            type: 'basic'
        },
        small: {
            width: 92,
            height: 27,
            type: 'basic'
        }
    };

    function getPlaceHolderState(props) {
        const widgetLayout = _.get(DEFAULT_SIZES[getStyleType(props.compProp)], 'type'),
            color = props.compProp.theme === 'dark' ? 'light' : 'dark',
            counter = props.compProp.showFollowersCount,
            stateArr = [];

        if (widgetLayout === 'basic') {
            stateArr.push('basic');
            stateArr.push('all');
        } else {
            stateArr.push('detailed');
            stateArr.push(color);
        }

        stateArr.push(counter ? 'show' : 'hide');

        return stateArr.join('_');
    }

    function sanitizeSpotifyURI(uri) {
        let sanitizedValue = null;
        if (uri) {
            const spotifyParts = uri.split(':');
            if (spotifyParts.length === 3) {
                sanitizedValue = `${spotifyParts[0]}:`.toLowerCase() +
                                 `${spotifyParts[1]}:`.toLowerCase() + spotifyParts[2] || '';
            }
        }
        return sanitizedValue;
    }

    function getIFrameSrc(props) {
        const srcArray = [];
        srcArray.push('https://open.spotify.com/follow/1/?uri=');
        const sanitizedURI = sanitizeSpotifyURI(props.compData.uri);
        srcArray.push(sanitizedURI);
        srcArray.push('&size=');
        srcArray.push(_.get(DEFAULT_SIZES[getStyleType(props.compProp)], 'type'));
        srcArray.push('&theme=');
        srcArray.push(props.compProp.theme);
        srcArray.push('&show-count=');
        srcArray.push(props.compProp.showFollowersCount ? 1 : 0);
        return srcArray.join('');
    }

    function getIFrameProperties(hasValidUri, props) {
        const iFrameProps = {};

        if (hasValidUri) {
            iFrameProps['data-src'] = getIFrameSrc(props);
            iFrameProps.style = {
                width: DEFAULT_SIZES[getStyleType(props.compProp)].width,
                height: DEFAULT_SIZES[getStyleType(props.compProp)].height
            };
        } else {
            iFrameProps.style = {
                display: 'none'
            };
        }

        return iFrameProps;
    }

    function getPlaceHolderProperties(hasValidUri) {
        const placeHolderProps = {};

        if (hasValidUri) {
            placeHolderProps.style = {
                display: 'none'
            };
        }

        return placeHolderProps;
    }

    function checkValidUri(uri) {
        return _.size(uri) > 0;
    }

    function getValidSpotifyDimensions(props) {
        const layout = DEFAULT_SIZES[getStyleType(props.compProp)];
        return {
            //We add stupid extra 2 pixels for backward compatibility with HTML-CLIENT
            height: layout.height + 2,
            width: layout.width
        };
    }

    function getStyleType(compProp) {
        return compProp.showFollowersCount ? `${compProp.size}WithCounter` : compProp.size;
    }

    /**
     * @class components.SpotifyFollow
     * @extends {core.skinBasedComp}
     */
    const spotifyFollow = {
        displayName: 'SpotifyFollow',
        mixins: [componentsCore.mixins.skinBasedComp],
        DEFAULT_SIZES,

        propTypes: {
            compData: santaComponents.santaTypesDefinitions.Component.compData,
            compProp: santaComponents.santaTypesDefinitions.Component.compProp
        },

        getInitialState() {
            return {
                $placeholder: getPlaceHolderState(this.props)
            };
        },

        componentWillReceiveProps(nextProps) {
            this.setState({$placeholder: getPlaceHolderState(nextProps)});
        },

        getSkinProperties() {
            const hasValidUri = checkValidUri(this.props.compData.uri);
            const iframeProperties = getIFrameProperties(hasValidUri, this.props);
            return {
                '': {
                    style: getValidSpotifyDimensions(this.props),
                    'data-valid-uri': `${hasValidUri}`,
                    'data-src': iframeProperties['data-src'],
                    tagName: 'wix-iframe'
                },
                iframe: iframeProperties,
                placeholder: getPlaceHolderProperties(hasValidUri)
            };
        }
    };

    componentsCore.compRegistrar.register('wysiwyg.common.components.spotifyfollow.viewer.SpotifyFollow', spotifyFollow);
    skinsPackage.skinsMap.addBatch(skinsJson);

    return spotifyFollow;
});
